import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Icon } from "../../icons/whitearrow.svg";
import SectionHeader from "../SectionHeader";
import CustomModal from "../CustomModal";
import TestimonialForm from "./TestiMonialForm";
import { useGetAllTestimonial } from "../../hooks/useGetTestimonial";
import Loader from "../utils/Loader";
import Error from "../utils/Error";

const Testimonialnew = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [widthTimes, setWidthTimes] = useState(1);
  const [width, setWidth] = useState();
  const [startX, setStartX] = useState(null);
  const [id, setId] = useState(0);
  const ref = useRef();
  const [showModal, setShowModal] = useState(false);
  const {
    data: testimonial,
    isLoading,
    isError,
    error,
  } = useGetAllTestimonial();

  let truncatedtext = testimonial?.data?.map((el, i) =>
    el.comments.length > 350 ? el.comments.slice(0, 350) : el.comments
  );

  useEffect(() => {
    setWidthTimes(testimonial?.data?.length);
  }, [testimonial?.data]);

  useEffect(() => {
    if (testimonial?.data?.length) {
      setWidth(ref.current.clientWidth);
      let handleWidth = () => {
        if (ref.current) {
          let width = ref.current.clientWidth;
          setWidth(width);
        }
      };
      window.addEventListener("resize", handleWidth);
      return () => window.removeEventListener("resize", handleWidth);
    }
  }, [testimonial?.data]);

  const togglereadmore = (index) => {
    setId(index);
    setExpanded(true);
  };

  const handlePrevious = () => {
    setCurrentItem((prev) => (prev > 0 ? prev - 1 : prev));
    setExpanded(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleNext = () => {
    if (width > 768) {
      setCurrentItem((prev) => (prev < widthTimes - 1 ? prev + 1 : prev));
    } else {
      setCurrentItem((prev) => (prev < widthTimes - 1 ? prev + 1 : prev));
    }
    setExpanded(false);
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (!startX) return;

    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (diffX > 50) {
      handleNext();
      setStartX(null);
    } else if (diffX < -50) {
      handlePrevious();
      setStartX(null);
    }
  };

  if (isLoading) return <Loader />;

  if (error)
    return (
      <Error message={error ? error.message : "Error Loading NewsLetter"} />
    );

  return (
    <div className="w-full flex justify-center ">
      <div className="2xl:container w-full p-4 lg:px-20 py-12 ">
        <SectionHeader
          title={"OUR TESTIMONIAL"}
          description={"What Families Say About Social Spectrum"}
        />
        <div>
          <button
            onClick={() => setShowModal(true)}
            className="py-3 px-6 md:px-[25px] md:py-[16px] bg-[#002DA3] text-16 font-semibold text-white font-[600] rounded-[32px]"
          >
            Add Testimonial
          </button>
        </div>
        {testimonial?.data?.length ? (
          <>
            <div className="flex  md:mt-8  justify-center items-center">
              <div className="w-full md:w-[90%] flex justify-center md:justify-between items-center">
                <button
                  onClick={handlePrevious}
                  className="hidden md:flex  h-[45px] w-[45px] rounded-full border-[1px] text-highlight border-highlight hover:text-white hover:bg-highlight flex justify-center items-center"
                >
                  <Icon className="rotate-180  arrowicon" />
                </button>
                <div
                  ref={ref}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  className="flex w-full md:w-10/12 relative overflow-hidden"
                >
                  <div
                    className={`relative flex w-[${
                      width * testimonial.data.length
                    }] transistion-transform duration-300`}
                    style={{
                      transform: `translateX(-${currentItem * width}px)`,
                    }}
                  >
                    {testimonial.data.map((comm, index) => (
                      <div
                        key={index}
                        className="p-[25px] flex items-center"
                        style={{ width: width ? `${width}px` : "966px" }}
                      >
                        <div
                          className={`px-4 w-full md:px-8 py-8 flex flex-col  md:flex-row items-center md:items-start gap-4 md:gap-8 bg-white rounded-[16px] shadow-services`}
                        >
                          <div className="w-auto">
                            {comm.img ? (
                              <img
                                className="h-[50px] w-[50px] rounded-full shadow-services"
                                src={process.env.PUBLIC_URL + `${comm.img}`}
                                alt="profile_img"
                              />
                            ) : (
                              <img
                                className="w-auto h-[50px] w-[50px] rounded-full shadow-services"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/event/img2.png"
                                }
                                alt="profile_img"
                              />
                            )}
                          </div>
                          <div className="flex flex-col w-[95%] md:w-[85%] gap-4">
                            <div>
                              <h1 className="text-center md:text-left capitalize text-18 md:text-24 font-semibold text-headingtext">
                                {comm.name}
                              </h1>
                              {comm.organization && (
                                <p className="text-center md:text-left text-16 mt-[4px] md:text-18 text-paratext font-semibold">
                                  {comm.organization}
                                </p>
                              )}
                            </div>
                            <p className="text-center md:text-left text-16 md:text-18 text-paratext">
                              {index === id && expanded
                                ? comm.comments
                                : `${truncatedtext[index]}  `}
                              <span>
                                {comm.comments.length > 400 && (
                                  <button
                                    onClick={() => togglereadmore(index)}
                                    className="text-F74900"
                                  >
                                    {index === id && expanded
                                      ? ""
                                      : "Read More"}
                                  </button>
                                )}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <button
                  onClick={handleNext}
                  className="hidden md:flex h-[45px] w-[45px] rounded-full border-[1px] text-highlight border-highlight hover:text-white hover:bg-highlight flex justify-center items-center testibtn"
                >
                  <Icon className="arrowicon" />
                </button>
              </div>
            </div>
            <div className="flex gap-5 text-white mt-5 w-full justify-center min-[768px]:hidden">
              <button
                onClick={handlePrevious}
                className=" flex h-[45px] w-[45px]  rounded-full border-[1px] text-highlight border-highlight hover:text-white hover:bg-highlight flex justify-center items-center"
              >
                <Icon className=" arrowicon rotate-180" />
              </button>
              <button
                onClick={handleNext}
                className="flex h-[45px] w-[45px] rounded-full border-[1px] text-highlight border-highlight hover:text-white hover:bg-highlight  flex justify-center items-center"
              >
                <Icon className="arrowicon" />
              </button>
            </div>
          </>
        ) : (
          <>
            {" "}
            <h4 className="text-24 text-center font-[800] text-headingtext mt-10 ">
              {" "}
              No Testimonials Available
            </h4>
          </>
        )}
      </div>

      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={"Create Testimonial"}
      >
        <div className="w-full  ">
          <TestimonialForm showModal={handleClose} />
        </div>
      </CustomModal>
    </div>
  );
};

export default Testimonialnew;
